<div (click)="onClick()" [className]="class">{{text}}</div>
